import React from "react";
import { Form } from "react-bootstrap";

export interface Permission {
  id: string;
  code: string;
  description: string;
}

interface RolePermissionsSectionProps {
  permissions: Permission[];
  selectedCodes: Set<string>;
  readOnly?: boolean;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  onToggle?: (code: string) => void;
  /** Unique instance id for checkbox ids when multiple sections exist */
  instanceId?: string;
  loading?: boolean;
}

const RolePermissionsSection: React.FC<RolePermissionsSectionProps> = ({
  permissions,
  selectedCodes,
  readOnly = false,
  searchValue = "",
  onSearchChange,
  onToggle,
  instanceId = "role",
  loading = false,
}) => {
  // Permissions list is already filtered & ordered by the caller.
  // We render in the given order so items do not jump when toggled.
  const filteredPermissions = permissions;

  return (
    <div className="create-role-permissions">
      <h3 className="create-role-permissions-title">
        Permissions ({selectedCodes.size})
      </h3>
      <div className="create-role-permissions-list">
        {!readOnly && (
          <Form.Control
            type="text"
            placeholder="Search"
            value={searchValue}
            onChange={(e) => onSearchChange?.(e.target.value)}
            className="create-role-permission-search"
          />
        )}
        <div className="create-role-permission-items">
          {loading ? (
            <div className="text-muted small py-3">Loading permissions...</div>
          ) : (
            filteredPermissions.map((perm) => (
              <div key={perm.id} className="create-role-permission-item">
                <Form.Check
                  type="checkbox"
                  id={`${instanceId}-perm-${perm.id}`}
                  checked={selectedCodes.has(perm.code)}
                  onChange={() => onToggle?.(perm.code)}
                  disabled={readOnly}
                  className="create-role-permission-check"
                />
                <span className="create-role-permission-tag">{perm.code}</span>
                <span className="create-role-permission-desc">
                  - {perm.description}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default RolePermissionsSection;
